import {
  createUniComponentFromWebComponent,
  type DataViewWidgetProps,
} from '../../core/index.js';
import { DataViewHeaderViews } from './views-view.js';

export const widgetViewsBar = createUniComponentFromWebComponent<
  DataViewWidgetProps & {
    activateCurrentViewOnClick?: boolean;
    onChangeView?: (viewId: string) => void;
    openOptionsOnActiveViewClick?: boolean;
    selectedViewId?: string | null;
  }
>(DataViewHeaderViews);
